import {useEffect, useRef} from "react";
import {Chart, registerables} from "chart.js";
import $ from 'jquery';

Chart.register(...registerables);

const AppChart = (
    {
        type = 'bar',
        data = {datasets: [], labels: []},
        title = '',
        titleX = '',
        titleY = '',
        barRadius = 0,
        stackedX = false,
        stackedY = false,
        legend = false,
        legendFont = '',
        legendAlign = 'end',    // start, center, end
        legendPosition = 'top', //top, left, bottom, right, chartArea
        labelsX = true,
        labelsY = true,
        labelSize = 14,
        labelFonts = '',
        borderX = true,
        borderY = true,
        barPercentage = 1,
        categoryPercentage = 0.8,

        gridX = true,
        gridY = true,

        paddingTop = 40,
        paddingLeft = 0,
        paddingBottom = 0,
        tooltip = true,
        axisDisplay = true,
        formatter = 'test',
    }
) => {
    const ctx = useRef();

    useEffect(() => {
        const chart = new Chart($(ctx.current), {
            type: type,
            data: data,
            options: {
                barPercentage: barPercentage,
                categoryPercentage: categoryPercentage,
                borderSkipped: false,
                scaleBeginAtZero: true,
                responsive: true,
                maintainAspectRatio: false,
                borderRadius: barRadius,
                scales: {
                    x: {
                        grid: {
                            display: gridX,
                            drawBorder: false,
                        },
                        title: {
                            text: titleX,
                            font: {
                                size: 15,
                                family: 'PT Sans bold'
                            }
                        },
                        stacked: stackedX,
                        display: axisDisplay,
                        ticks: {
                            display: labelsX,
                            autoSkip: true,
                            font: {
                                size: labelSize,
                                family: labelFonts
                            }
                        },
                        border: {
                            display: borderX,
                        }
                    },
                    y: {
                        beginAtZero: true,
                        grid: {
                            display: gridY,
                            drawBorder: false,
                        },
                        title: {
                            text: titleY,
                            font: {
                                size: 15,
                                family: 'PT Sans bold'
                            },
                            padding: {
                                top: 0,
                                bottom: 0
                            }
                        },
                        stacked: stackedY,
                        ticks: {
                            display: labelsY,
                            font: {
                                size: labelSize,
                                family: labelFonts
                            }
                        },
                        display: axisDisplay,
                        border: {
                            display: borderY,
                        }
                    },

                },
                layout: {
                    padding: {
                        top: paddingTop,
                        left: paddingLeft,
                        bottom: paddingBottom
                    }
                },
                plugins: {
                    title: {
                        text: title,
                        align: 'start',
                        color: 'red',
                        font: {
                            size: 14
                        }
                    },
                    legend: {
                        position: legendPosition,
                        display: legend,
                        align: legendAlign,
                        labels: {
                            usePointStyle: true,
                            pointStyle: 'circle',
                            boxWidth: 8,
                            boxHeight: 8,
                            padding: 20,
                            font: {
                                family: legendFont
                            },

                        }
                    },

                    tooltip: {
                        enabled: tooltip,
                    },
                    datalabels: {
                        labels: {
                            title: {
                                font: {
                                    weight: 'bold'
                                }
                            }
                        }
                    }
                }
            }
        });
        return () => {
            chart.destroy();
        }
    }, [data])

    return (
        <canvas ref={ctx} className="myChart'"></canvas>
    )
}

export default AppChart;
